import React from 'react';
import useUserInfo from "../../hooks/useUserInfo";

const Unauthorized = () => {
  const {role} = useUserInfo()

  return (
    <div>
      <p>Your role does not have permissions to access this feature.</p>

      <p>Your current role: {role || 'Role not set'}</p>
    </div>
  );
};

export default Unauthorized;


// WEBPACK FOOTER //
// ./src/components/Notice/Unauthorized.js